export const ru = {
    'autobudget-label': 'Приоритет автобюджета',
    cancel: 'Отменить',
    update: 'Изменить'
};
